<div class="page">
  <app-otp #otpComponent [phoneNumber]="phoneNumber" [token]="token"></app-otp>
</div>